import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/img/logo.png";
import "./style.css";

const companyLinks = [
  { label: "Company", to: "/about/company" },
  { label: "Career", to: "/about/career" },
  { label: "Contact", to: "/about/contact" },
];

const serviceLinks = [
  { label: "AI Applications", to: "/services/ai-applications" },
  { label: "Web Application", to: "/services/web-applications" },
  { label: "Mobile Application", to: "/services/mobile-applications" },
  { label: "Cloud Deployment", to: "/services/cloud-deployment" },
  { label: "MessageHub", to: "/services/messagehub" },
];

const productLinks = [
  { label: "UniBuilder", to: "/products/unibuilder" },
  { label: "Task Alarm", to: "/products/task-alarm" },
  { label: "AI Bridge", to: "/products/ai-bridge" },
  { label: "Knowledge Graph", to: "/products/knowledge-graph" },
];

const industryLinks = [
  { label: "Finance", to: "/industries/finance" },
  { label: "Health Care", to: "/industries/healthcare" },
  { label: "Education", to: "/industries/education" },
  { label: "Logistics", to: "/industries/logistics" },
  { label: "AI Products", to: "/industries/ai-products" },
];

// const legalLinks = [
//   "Unibuilder",
//   "Privacy Policy",
//   "Terms of Service",
//   "Cookie Settings",
// ];

export default function Footer() {
  return (
    <footer className="footer">
      {/* ── Main body ── */}
      <div className="container footer-body">
        <div className="row gy-5">
          {/* Brand column */}
          <div className="col-lg-4 col-md-12 col-12">
            <div className="footer-brand">
              <div className="footer-logo">
                {/* <span className="footer-logo-mark" aria-hidden="true" /> */}
                <div className="logo-icon">
                  <img src={logo} alt="BCT" className="logo-img" />
                </div>
                <span className="footer-logo-name">Best Code Technology</span>
              </div>

              <p className="footer-tagline">
                Reach Heights with Tech. We build AI-first products for
                ambitious startups and established enterprises.
              </p>
            </div>
          </div>

          {/* Services links */}
          <div className="col-lg-2 col-md-3 col-6">
            <p className="footer-col-heading">Services</p>
            <ul className="footer-links">
              {serviceLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="footer-link">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Products links */}
          <div className="col-lg-2 col-md-3 col-6">
            <p className="footer-col-heading">Products</p>
            <ul className="footer-links">
              {productLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="footer-link">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Industries links */}
          <div className="col-lg-2 col-md-3 col-6">
            <p className="footer-col-heading">Industries</p>
            <ul className="footer-links">
              {industryLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="footer-link">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* About links */}
          <div className="col-lg-2 col-md-3 col-6">
            <p className="footer-col-heading">About</p>
            <ul className="footer-links">
              {companyLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="footer-link">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* ── Divider ── */}
      <div className="container">
        <hr className="footer-divider" />
      </div>

      {/* ── Bottom bar ── */}
      <div className="container footer-bottom">
        <div className="row align-items-center">
          <div className="col">
            <p className="footer-copyright">
              &copy; 2026 Best Code Technology. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
